// SPDX-FileCopyrightText: Copyright (C) 2026 provide.io llc
// SPDX-License-Identifier: Apache-2.0

export interface RuntimeAuthConfig {
  readonly issuer: string;
  readonly clientId: string;
  readonly scopes: readonly string[];
  readonly redirectUri?: string;
}

export interface RuntimeConfig {
  readonly apiBase: string;
  readonly auth: RuntimeAuthConfig | null;
  readonly branding: { readonly title: string };
}

const WELL_KNOWN = "/.well-known/uwhois-web-config.json";
const FALLBACK = "/config.json";

async function tryFetch(url: string): Promise<RuntimeConfig | null> {
  try {
    const r = await fetch(url, { headers: { accept: "application/json" } });
    if (!r.ok) return null;
    return (await r.json()) as RuntimeConfig;
  } catch {
    return null;
  }
}

export async function loadConfig(): Promise<RuntimeConfig> {
  const fromWellKnown = await tryFetch(WELL_KNOWN);
  if (fromWellKnown) return fromWellKnown;
  const fromBundle = await tryFetch(FALLBACK);
  if (fromBundle) return fromBundle;
  throw new Error(
    "runtime config not found at /.well-known/uwhois-web-config.json or /config.json",
  );
}
